export default "__VITE_ASSET__c7162500__"